import React, { FC, useRef, useEffect, useCallback, memo } from "react";
import { createUseStyles } from "react-jss";

import ZoomOut from "Assets/images/zoom_map_minus.svg";
import ZoomIn from "Assets/images/zoom_map_plus.svg";

import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  setZoom: (val: number) => void;
  mapObj: any;
}

const ZoomControl: FC<Props> = memo((props: Props) => {
  const { setZoom, mapObj } = props;
  const zoomOut = useRef(null);
  const zoomIn = useRef(null);
  const zoomControl = useRef(null);

  const useStyles = createUseStyles(styles);

  const classes = useStyles({ ...props });
  const zoomOutClick = useCallback(() => {
    const currentZoomLevel = mapObj.getZoom();
    if (currentZoomLevel !== 0) {
      mapObj.setZoom(currentZoomLevel - 1);
      setZoom(currentZoomLevel - 1);
    }
  }, [mapObj, setZoom]);
  const zoomInClick = useCallback(() => {
    const currentZoomLevel = mapObj.getZoom();
    if (currentZoomLevel !== 21) {
      mapObj.setZoom(currentZoomLevel + 1);
      setZoom(currentZoomLevel + 1);
    }
  }, [mapObj, setZoom]);
  useEffect(() => {
    // These will store the reference to the domListener and will use the remove method when the component unmounts
    let zoomOutListener: any;
    let zoomInListener: any;
    if (mapObj) {
      const { addDomListener } = window.google.maps.event;
      zoomOutListener = addDomListener(zoomOut.current, "click", zoomOutClick);
      zoomInListener = addDomListener(zoomIn.current, "click", zoomInClick);
    }

    return () => {
      // Remove the event listenters
      // Although this is from the Google Map docs, eslint does not like this.
      zoomOutListener?.remove(); //eslint-disable-line
      zoomInListener?.remove(); //eslint-disable-line
    };
  }, [mapObj, zoomInClick, zoomOutClick, zoomOut]);

  return (
    <div
      className={classes.container}
      ref={zoomControl}
      data-testid="zoom-container"
    >
      <button
        tabIndex={0}
        type="button"
        className={classes.inOut}
        aria-label="Zoom In"
        ref={zoomIn}
        data-testid="zoom-in"
      >
        <ZoomIn />
      </button>
      <div className={classes.dividerContainer}>
        <div className={classes.divider} data-testid="zoom-divider" />
      </div>
      <button
        className={classes.inOut}
        type="button"
        aria-label="Zoom Out"
        ref={(ref) => {
          zoomOut.current = ref;
        }}
        data-testid="zoom-out"
        tabIndex={0}
      >
        <ZoomOut />
      </button>
    </div>
  );
}, areEqualShallow);

export default ZoomControl;
try {
    // @ts-ignore
    ZoomControl.displayName = "ZoomControl";
    // @ts-ignore
    ZoomControl.__docgenInfo = { "description": "", "displayName": "ZoomControl", "props": { "setZoom": { "defaultValue": null, "description": "", "name": "setZoom", "required": true, "type": { "name": "(val: number) => void" } }, "mapObj": { "defaultValue": null, "description": "", "name": "mapObj", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ZoomControl/ZoomControl.tsx#ZoomControl"] = { docgenInfo: ZoomControl.__docgenInfo, name: "ZoomControl", path: "src/shared/components/ZoomControl/ZoomControl.tsx#ZoomControl" };
}
catch (__react_docgen_typescript_loader_error) { }